import {PipelinePhaseCard} from './PipelinePhaseCard';
import type {OnboardingItem} from './PipelinePhaseCard';

interface PipelineKanbanBoardProps {
  onboardings: OnboardingItem[];
}

const phases = [
  {key: 'INITIAL_SETUP', label: 'Initial Setup', color: 'border-t-brand-navy'},
  {key: 'PRE_ENROLLMENT', label: 'Pre-Enrollment', color: 'border-t-brand-blue'},
  {key: 'ENROLLMENT', label: 'Enrollment', color: 'border-t-brand-blue-light'},
  {key: 'GO_LIVE_PREP', label: 'Go Live Prep', color: 'border-t-amber-500'},
  {key: 'POST_LAUNCH', label: 'Post Launch', color: 'border-t-emerald-500'},
] as const;

export function PipelineKanbanBoard({onboardings}: PipelineKanbanBoardProps) {
  return (
    <div className='flex gap-4 overflow-x-auto pb-4 min-h-[500px]'>
      {phases.map((phase) => {
        const items = onboardings.filter((o) => o.currentPhase === phase.key);

        return (
          <div
            key={phase.key}
            className='min-w-[280px] w-[280px] bg-gray-50 rounded-lg border flex flex-col'
          >
            <div className={`px-3 py-2 border-t-4 ${phase.color}`}>
              <div className='flex items-center justify-between'>
                <span className='font-semibold text-sm text-brand-navy'>{phase.label}</span>
                <span className='inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-gray-200 text-xs font-medium text-brand-gray'>
                  {items.length}
                </span>
              </div>
            </div>

            <div className='flex-1 overflow-y-auto p-2 flex flex-col gap-2'>
              {items.length === 0 ? (
                <p className='text-xs text-brand-gray-light italic text-center mt-4'>No groups</p>
              ) : (
                items.map((onboarding) => (
                  <PipelinePhaseCard key={onboarding.id} onboarding={onboarding} />
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
